import { render, staticRenderFns } from "./Form49Layout.vue?vue&type=template&id=4a8c7254&scoped=true"
import script from "./Form49Layout.vue?vue&type=script&lang=ts"
export * from "./Form49Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=4a8c7254&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c7254",
  null
  
)

export default component.exports